<template>
  <div>
    <Modal v-model="editModal" :closable="false" :mask-closable="false" title="修改密码">
      <Form ref="formValidate" :label-width="100" :model="formValidate" :rules="ruleValidate">
        <FormItem label="密码：" prop="originPwd">
          <Input
              v-model="formValidate.originPwd"
              placeholder="请输入原密码"
              type="password"
              @on-keyup="formValidate.originPwd=formValidate.originPwd.replace(regular.delBlankSpace,'')"
          />
        </FormItem>
        <FormItem label="新密码：" prop="firstPassword">
          <Input
              v-model="formValidate.firstPassword"
              placeholder="请输入新密码"
              type="password"
              @on-keyup="formValidate.firstPassword=formValidate.firstPassword.replace(regular.delBlankSpace,'')"
          />
        </FormItem>
        <FormItem label="确认密码：" prop="newPwd">
          <Input
              v-model="formValidate.newPwd"
              placeholder="请再次输入新密码"
              type="password"
              @on-keyup="formValidate.newPwd=formValidate.newPwd.replace(regular.delBlankSpace,'')"
          />
        </FormItem>
      </Form>
      <div class="must-change-tips">
提示：为了保证密码的安全性，需要根据系统设置调整密码复杂度，并建议定期更改密码，比如每隔3个月更改一次。
</div>
      <Row slot="footer">
        <Button type="primary" @click="editSure">
确定
</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import { regular } from '@/lib/regular';
import { accountApi } from '../../api/account';
export default {
  name: '',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data () {
    return {
      regular,
      editModal: false,
      formValidate: {},
      ruleValidate: {
        originPwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            pattern: regular.pwd,
            message: regular.pwdDesc,
            trigger: 'blur'
          }
        ],
        firstPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            pattern: regular.pwdV2,
            message: regular.pwdV2Desc,
            trigger: 'blur'
          }
        ],
        newPwd: [
          {
            required: true,
            message: '请输入确认密码',
            trigger: 'blur'
          },
          {
            pattern: regular.pwdV2,
            message: regular.pwdV2Desc,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    userMustChangePwd () {
      return this.$store.getters['user/getUserMustChangePwd'];
    }
  },
  watch: {
    userMustChangePwd (val) {
      this.editModal = false;
      if (val) {
        this.editModal = true;
      }
    }
  },
  created () {
  },
  mounted () {
    if (this.userMustChangePwd) {
      this.editModal = true;
    }
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  activated () {
  },
  methods: {
    logout () {
      this.$store.commit('user/clearUserInfo');
    },
    async savePassword () {
      this.$Spin.show();
      try {
        const result = await accountApi.updatePassword(this.formValidate);
        this.$Message.success('修改密码成功');
        this.$refs.formValidate.resetFields();
        this.editModal = false;
        this.$Spin.hide();
        this.logout();
      } catch (e) {
        this.$smartSentry.captureException(e);
        console.log(e);
        this.$Spin.hide();
      }
    },
    editSure () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          if (this.formValidate.newPwd !== this.formValidate.firstPassword) {
            return this.$Message.error('两次输入密码不一致，请重新输入！！');
          }
          this.savePassword();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.must-change-tips{
  color:#f00;
}
</style>
